import { createSlice } from '@reduxjs/toolkit';
import { EModalStatus, IPageState } from '../../../types/referrer/page';

const initialState: IPageState = {
  stickyScrollBtnVisible: false,
  modals: {
    isOpen: false,
    status: EModalStatus.GetVerificationCode,
    action: null,
    error: '',
  },
  referralLinkFallbackModal: {
    isOpen: false,
    referralLink: '',
  },
};

const referrerPageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setModalOpen(state) {
      state.modals.isOpen = true;
    },
    setModalClose(state) {
      state.modals.isOpen = false;
      state.modals.status = EModalStatus.GetVerificationCode;
      state.modals.action = null;
    },
    setModalAction(state, action) {
      state.modals.action = action.payload;
    },
    setModalError(state, action) {
      state.modals.error = action.payload;
    },
    setModalStatus(state, action) {
      state.modals.status = action.payload;
    },
    toggleStickyScrollBtn(state, action) {
      state.stickyScrollBtnVisible = action.payload;
    },
    setReferralLinkFallbackModalOpen(state, action) {
      state.referralLinkFallbackModal = {
        isOpen: true,
        referralLink: action.payload,
      };
    },
    setReferralLinkFallbackModalClose(state) {
      state.referralLinkFallbackModal = {
        isOpen: false,
        referralLink: '',
      };
    },
  },
});

export const {
  reducer: referrerPageReducer,
  actions: {
    toggleStickyScrollBtn,
    setModalStatus,
    setModalOpen,
    setModalAction,
    setModalError,
    setModalClose,
    setReferralLinkFallbackModalOpen,
    setReferralLinkFallbackModalClose,
  },
} = referrerPageSlice;
